import React from "react";
import Box from "@mui/material/Box";
import Banner from "./Banner.js";
import "./index.css";
import styled from "@emotion/styled";

// Defined at module scope, not inside Init. styled() returns a new component
// type on every call, so building it in the render body handed React a
// different type at the same position each time — which is a full unmount and
// remount of everything below it, not a re-render. Anything the subtree held in
// the DOM went with it: on /activate, typing a character re-rendered the parent,
// the input was destroyed and rebuilt, focus was lost, and only that first
// character ever landed. Login never showed it because its fields are
// uncontrolled and so nothing re-renders while you type.
const FlexContainer = styled(Box)({
  display: "flex",
  width: "100%",
});

function Init(props) {
  return (
    <FlexContainer minHeight="100vh">
        <Box width="29.29rem" display="flex">
          <Banner />
        </Box>
        <FlexContainer
          flexGrow={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Box display="flex" padding="1.56rem" flexGrow={1}>
            {props.children}
          </Box>
        </FlexContainer>
    </FlexContainer>
  );
}

export default Init;
